import useDocumentTitle from 'hooks/useDocumentTitle';

const useDocumentTitleUnread = (unreadCount, { maxDisplay = 99 } = {}) => {
  const label = unreadCount > maxDisplay ? `${maxDisplay}+` : String(unreadCount);

  useDocumentTitle(null, { prefix: unreadCount ? `(${label}) ` : null });
};

export default useDocumentTitleUnread;
